import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const AcceptChanges = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.8144 5.92649C14.0391 6.08699 14.0911 6.39926 13.9306 6.62397L9.64493 12.624C9.56288 12.7388 9.43609 12.8137 9.29587 12.83C9.15565 12.8463 9.01507 12.8026 8.90882 12.7097L6.3374 10.4598C6.12957 10.278 6.1085 9.96212 6.29033 9.7543C6.47216 9.54647 6.78804 9.5254 6.99587 9.70723L9.15196 11.5937L13.1169 6.04273C13.2774 5.81803 13.5897 5.76598 13.8144 5.92649Z"
          fill={color}
        />
        <path opacity="0.3" d="M3 4.66666L11 4.66666" stroke={color} strokeLinecap="round" />
        <path opacity="0.3" d="M3 7.33333H9" stroke={color} strokeLinecap="round" />
      </svg>
    )
  },
)

export default AcceptChanges
